<template>
  <div>
    <b-upload
      v-if="isDraggable"
      class="file-label is-block"
      :accept="getAcceptMimeTypes()"
      @input="setFileId"
      multiple
      drag-drop
    >
      <section class="section">
        <div class="content has-text-centered">
          <p>
            <b-icon
              pack="fas"
              icon="upload"
              size="is-large"
            ></b-icon>
          </p>
          <p>{{ $t('form.SelectFilesDragAndDrop') }}</p>
        </div>
      </section>
    </b-upload>

    <b-upload
      v-else
      v-model="files"
      class="file-label"
      multiple
      :accept="getAcceptMimeTypes()"
      @input="setFileId"
    >
      <span class="file-cta">
        <b-icon
          class="file-icon"
          pack="fas"
          icon="upload"
        ></b-icon>
        <span class="file-label">{{ buttonLabel }}</span>
      </span>
    </b-upload>
  </div>
</template>
<script>
export default {
  name: 'FileInput',

  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },

    uploaderOptions: {
      type: Object,
      required: true,
      default: null,
    },

    isDraggable: {
      type: Boolean,
      default: false,
    },

    enableCaption: {
      type: Boolean,
      default: false,
    },

    enableInsertButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      files: [],
    }
  },

  computed: {
    buttonLabel() {
      const labelKey = this.fileType === 'image' ? 'form.SelectImages' : 'form.SelectFiles'
      return this.$t(labelKey)
    },
  },

  methods: {
    setFileId(vals) {
      console.log('setFileId', vals)
      this.$emit('input', vals)
    },

    getUploadConfig(key, defaultVal) {
      console.log('getUploadConfig', key, defaultVal, this.uploaderOptions)
      if (this.checkEmpty(this.uploaderOptions) === true) return defaultVal
      if (this.checkEmpty(key) === true) return defaultVal
      if (this.checkEmpty(this.uploaderOptions[key]) === true) return defaultVal
      return this.uploaderOptions[key]
    },

    getAcceptMimeTypes() {
      if (this.uploaderOptions.mimeTypes !== undefined) {
        return this.uploaderOptions.mimeTypes
      }
    },
  },
}
</script>
